import React, { FC } from 'react';
import { Keyword } from '../../../domain/models';
import { KeywordFilterButtons } from './KeywordFilterButtons';

interface IKeywordFilterProps {
	disabled?: boolean;
	currentKeyword?: Keyword;
	onChangeKeyword: (keyword?: Keyword) => void;
}

export const KeywordFilter: FC<IKeywordFilterProps> = ({
	disabled,
	currentKeyword,
	onChangeKeyword,
}) => {
	const onClickKeywordFilter = (keyword?: Keyword) => {
		if (disabled) return;

		onChangeKeyword(keyword);
	};

	return (
		<KeywordFilterButtons
			disabled={disabled}
			currentKeyword={currentKeyword}
			onClickKeywordFilter={onClickKeywordFilter}
		/>
	);
};
